unit SMX.Jobs.Shared;

interface

type
  TImportData = class
    private
    public
      OriginalFileName: string;
      TempFileName: string;
      Data: TArray<TArray<string>>;
      ColCount: integer;
      HasTitles: boolean;
      FieldDelimiter: string;
      RawLines: TArray<string>;
  end;



const
  JOBS_UPLOADED_FILE = 'UploadedFile';
  JOBS_TEMP_FILE = 'TempFileName';
  JOBS_ORIGINAL_FILENAME = 'OriginalFileName';
  ERR_UNRECOGNISED_ENCODING = -4001;

function FormatFieldDelimiterLabel(const ADelimiter: string): string;
function FieldDelimiterComboIndex(const ADelimiter: string): Integer;
function FieldDelimiterFromComboIndex(AIndex: Integer): Char;

implementation

const
  FIELD_DELIMITERS: array[0..3] of Char = (',', ';', #9, '|');

function FormatFieldDelimiterLabel(const ADelimiter: string): string;
var
  C: Char;
begin
  if ADelimiter = '' then
    C := ','
  else
    C := ADelimiter[1];

  case C of
    ',': Result := 'Comma (,)';
    ';': Result := 'Semicolon (;)';
    #9: Result := 'Tab';
    '|': Result := 'Pipe (|)';
  else
    Result := string(C);
  end;
end;

function FieldDelimiterComboIndex(const ADelimiter: string): Integer;
var
  C: Char;
  I: Integer;
begin
  if ADelimiter = '' then
    C := ','
  else
    C := ADelimiter[1];

  for I := Low(FIELD_DELIMITERS) to High(FIELD_DELIMITERS) do
    if FIELD_DELIMITERS[I] = C then
      Exit(I);

  Result := 0;
end;

function FieldDelimiterFromComboIndex(AIndex: Integer): Char;
begin
  if (AIndex >= Low(FIELD_DELIMITERS)) and (AIndex <= High(FIELD_DELIMITERS)) then
    Result := FIELD_DELIMITERS[AIndex]
  else
    Result := ',';
end;

end.
